var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1121 0.899576C15.8863 0.673342 15.5798 0.546206 15.2602 0.546206C14.9406 0.546206 14.6341 0.673342 14.4083 0.899576L8.49957 6.79624L2.59082 0.887493C2.28647 0.583147 1.84288 0.464286 1.42713 0.575685C1.01139 0.687083 0.686656 1.01182 0.575257 1.42756C0.463859 1.8433 0.58272 2.2869 0.887065 2.59124L6.79582 8.49999L0.887065 14.4087C0.58272 14.7131 0.463859 15.1567 0.575257 15.5724C0.686656 15.9882 1.01139 16.3129 1.42713 16.4243C1.84288 16.5357 2.28647 16.4168 2.59082 16.1125L8.49957 10.2037L14.4083 16.1125C14.7127 16.4168 15.1563 16.5357 15.572 16.4243C15.9877 16.3129 16.3125 15.9882 16.4239 15.5724C16.5353 15.1567 16.4164 14.7131 16.1121 14.4087L10.2033 8.49999L16.1121 2.59124C16.5712 2.13208 16.5712 1.35874 16.1121 0.899576Z",
    fill: "#3E4B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillCross);
export default __webpack_public_path__ + "static/media/bill_cross.26286f5165a116dca7de8c2ab58a6042.svg";
export { ForwardRef as ReactComponent };